// src/hook.ts
import * as React from "react";
var useSafeEffect = typeof window !== "undefined" ? React.useLayoutEffect : React.useEffect;
export {
  useSafeEffect
};
